import 'regenerator-runtime/runtime';
import { call, select, takeEvery } from 'redux-saga/effects';

import { GlobalActions, GlobalPut, VermerkInfo } from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { IAppState } from '../appState';

export function* initSpeichernVermerkSaga() {
  yield takeEvery(GlobalActions.TOGGLE_MODAL, safeSaga(initVermerk, App.SHOP_DASHBOARD));
  yield takeEvery(GlobalActions.KDV_METADATEN_REQUESTED, safeSaga(initVermerk, App.SHOP_DASHBOARD));
}

export function* initVermerk() {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  // The TGV entry only groups the offers of its child apps and has no price of its own.
  const selectedProducts = state.warenkorb.filter(produkt => produkt.appId !== App.TGV);

  const vermerkPayload: VermerkInfo[] = selectedProducts.map(produkt => ({
    sparte: produkt.produktKdvId,
    beitrag: produkt.bruttopreis,
  }));

  yield call(globalPut.put, new GlobalActions().vermerkInit(vermerkPayload));
}
